import { FC } from 'react';
import { Typography, VerticalSpace } from '@chargeafter/ui';
import { ContentContainer } from './ContentContainer';
import { MainButton } from '../MainButton';
import { ButtonName, ESendLinkModal } from '../../constants';
import { LinkInteraction } from '../../services/sendLinkManager';
import { DeliveryMethodFeedbackIcon } from './DeliveryMethodFeedbackIcon';
import { DeliveryMethodFeedbackMessage } from './DeliveryMethodFeedbackMessage';
import { Box, styled } from '@mui/material';
import { LinkError } from './LinkModal';

type LinkSentProps = {
  deliveryTarget: string;
  close: () => void;
  success: boolean;
  linkInteraction: LinkInteraction;
  onTryAgain: () => void;
  error?: LinkError;
  returnToCustomerData: () => void;
};

const StyledTypography = styled(Typography)({
  textAlign: 'center',
});

export const LinkSent: FC<LinkSentProps> = ({
  deliveryTarget,
  close,
  success,
  linkInteraction,
  onTryAgain,
  error,
  returnToCustomerData,
}) => {
  return (
    <ContentContainer data-testid="link-sent-feedback-modal">
      <DeliveryMethodFeedbackIcon
        success={success}
        deliveryMethod={linkInteraction.deliveryMethod}
      />
      <VerticalSpace units={3} />
      <StyledTypography>
        <DeliveryMethodFeedbackMessage
          deliveryMethod={linkInteraction.deliveryMethod}
          deliveryTarget={deliveryTarget}
          success={success}
        />
        {!success && (
          <>
            {error?.message ? (
              <Box>{error.message}</Box>
            ) : (
              ESendLinkModal.LinkFailedSupport1
            )}
          </>
        )}
      </StyledTypography>
      {!success && (
        <MainButton
          onClick={error ? returnToCustomerData : onTryAgain}
          variant="contained"
          fullWidth
          buttonName={getLinkErrorButtonName(error)}
        >
          {getLinkErrorButtonText(error)}
        </MainButton>
      )}
      <MainButton
        onClick={close}
        variant={success ? 'contained' : 'outlinedSecondary'}
        fullWidth
        buttonName={ButtonName.CloseLinkModal}
      >
        {ESendLinkModal.BackToMainScreen}
      </MainButton>
    </ContentContainer>
  );
};

const getLinkErrorButtonName = (error?: LinkError) => {
  switch (error?.code) {
    case '10201':
      return ButtonName.UpdateEmail;
    default:
      return ButtonName.TryAgain;
  }
};

const getLinkErrorButtonText = (error?: LinkError) => {
  switch (error?.code) {
    case '10201':
      return ESendLinkModal.UpdateEmail;
    default:
      return ESendLinkModal.TryAgain;
  }
};
